
jQuery(document).ready( function($){

	var _run = $('[javascript="users"]').length;

	var Users = function()
	{

		var container = $('[javascript="users"]');

		return {
			wysiwyg: function( selector )
			{
                $.fn.ensphere.veto.wysiwyg( selector, container );
			}
		};

	};


	if( _run ) {

		var api = new Users();
		api.wysiwyg( '.wysiwyg' );

	}

	$('[data-for="all-permissions"]').click(function(e){
		e.preventDefault();
		$('.route-name-list.inline.field input').prop('checked', true);
	});

});
